import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { cloneDeep, set } from 'lodash';
import { useMutationWithCacheUpdate, useTableDataState } from '../../state/table-data.state';

import lockIcon from '@ingka/ssr-icon/paths/lock';
import { useCallback } from 'react';
import { useSubItemsFromSelections } from '../../state/selection.state';

export const LockButton = () => {
   const mutate = useMutationWithCacheUpdate('Material(s) successfully locked');
   const selectedSubItems = useSubItemsFromSelections();

   const onClick = () => {
      const updated = selectedSubItems.map((subItem) => set(cloneDeep(subItem), 'locked', true));
      const updatedIds = new Set(updated.map((u) => `${u.parentId}:${u.id}`));
      const previousValues = new Map(
         selectedSubItems.map((s) => [`${s.parentId}:${s.id}`, s.locked])
      );

      useTableDataState.setState((state) => ({
         data: state.data.map((item) => ({
            ...item,
            subItems: item.subItems?.map((s) =>
               updatedIds.has(`${s.parentId}:${s.id}`) ? { ...s, locked: true } : s
            ),
         })),
      }));

      mutate(updated, {
         onError: () => {
            useTableDataState.setState((state) => ({
               data: state.data.map((item) => ({
                  ...item,
                  subItems: item.subItems?.map((s) =>
                     previousValues.has(`${s.parentId}:${s.id}`)
                        ? { ...s, locked: previousValues.get(`${s.parentId}:${s.id}`)! }
                        : s
                  ),
               })),
            }));
         },
      });
   };

   const areAnyUnlocked = useCallback(() => {
      let found = false;
      selectedSubItems.forEach((subItem) => {
         if (!subItem.locked) found = true;
      });
      return found;
   }, [selectedSubItems]);

   const buttonTooltip = () => {
      if (!areAnyUnlocked()) return 'You need to select unlocked row(s) to lock';
      else return 'Lock row';
   };

   return (
      <StyledTooltip title={buttonTooltip()}>
         <span>
            <StyledToolbarButton
               ssrIcon={lockIcon}
               text="Lock"
               iconOnly={true}
               small={true}
               onClick={onClick}
               disabled={!areAnyUnlocked()}
            />
         </span>
      </StyledTooltip>
   );
};